import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
var Feedback = /*#__PURE__*/function (_Component) {
  function Feedback(props) {
    var _this;
    _classCallCheck(this, Feedback);
    _this = _callSuper(this, Feedback, [props]);
    _this.state = {
      isReadingMore: false,
      showReadMore: false
    };
    _this.readMore = _this.readMore.bind(_this);
    return _this;
  }
  _inherits(Feedback, _Component);
  return _createClass(Feedback, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setShowReadMore();
    }
  }, {
    key: "setShowReadMore",
    value: function setShowReadMore() {
      // Added 1 to clientHeight because in Safari 12.1 there is a rounding error leading
      // scrollHeight to be bigger than the clientHeight by 1 and so showReadMore is true
      if (this.notesElement !== undefined) {
        this.setState({
          showReadMore: this.notesElement.scrollHeight > this.notesElement.clientHeight + 1
        });
      }
    }
  }, {
    key: "readMore",
    value: function readMore() {
      this.setState(function (prevState) {
        return {
          isReadingMore: !prevState.isReadingMore
        };
      });
    }
  }, {
    key: "renderDateAndReadMore",
    value: function renderDateAndReadMore() {
      var _this$state = this.state,
        isReadingMore = _this$state.isReadingMore,
        showReadMore = _this$state.showReadMore;
      var feedback = this.props.feedback;
      if (feedback.note && showReadMore) {
        return /*#__PURE__*/React.createElement("div", {
          className: "align"
        }, /*#__PURE__*/React.createElement("a", {
          className: "body-text-4",
          tabIndex: 0,
          role: "link",
          onClick: this.readMore
        }, ' ', isReadingMore ? 'Read Less' : 'Read More'), /*#__PURE__*/React.createElement("span", {
          className: "body-text-4 end no-wrap muted-gray-text"
        }, feedback.updated_at));
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "align"
      }, /*#__PURE__*/React.createElement("span", {
        className: "body-text-4 end no-wrap muted-gray-text"
      }, feedback.updated_at));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        feedback = _this$props.feedback,
        canCreateFeedback = _this$props.canCreateFeedback;
      var _this$state2 = this.state,
        isReadingMore = _this$state2.isReadingMore,
        showReadMore = _this$state2.showReadMore;
      return /*#__PURE__*/React.createElement("div", {
        className: "proposal-feedback-container can-create-".concat(canCreateFeedback),
        key: "feedback-".concat(feedback.email)
      }, /*#__PURE__*/React.createElement("div", {
        className: "feedback-body"
      }, /*#__PURE__*/React.createElement("div", {
        className: "avatar"
      }, feedback.initials), /*#__PURE__*/React.createElement("div", {
        className: "feedback-content"
      }, /*#__PURE__*/React.createElement("div", {
        className: "feedback"
      }, /*#__PURE__*/React.createElement("div", {
        className: "user-name"
      }, feedback.name || feedback.email), feedback.note && /*#__PURE__*/React.createElement("div", {
        className: "user-feedback ".concat(isReadingMore ? 'show' : 'overflow'),
        ref: function ref(el) {
          _this2.notesElement = el;
        }
      }, feedback.note), showReadMore && /*#__PURE__*/React.createElement("div", {
        className: "reading-more",
        onClick: this.readMore,
        tabIndex: 0,
        role: "button"
      }, isReadingMore ? 'Read Less' : 'Read More')), /*#__PURE__*/React.createElement("div", {
        className: "status ".concat(feedback.consultant_fit ? feedback.consultant_fit : '')
      }, feedback.consultant_fit ? feedback.consultant_fit.toUpperCase() : ''))), /*#__PURE__*/React.createElement("div", {
        className: "feedback-footer"
      }, /*#__PURE__*/React.createElement("div", {
        className: "timestamp"
      }, feedback.updated_at)));
    }
  }]);
}(Component);
Feedback.propTypes = {
  canCreateFeedback: PropTypes.bool.isRequired,
  feedback: PropTypes.shape({}).isRequired
};
export default Feedback;